import React, { useMemo } from "react";
import { ThemeProvider as Provider } from "styled-components";

import { useTheme } from "../../hooks/useTheme";
import { useShopifyApp } from "../../hooks/useShopifyApp";
import { testTheme } from "../../theme/testTheme";
import { shopifyTheme } from "../../theme/shopifyTheme";
import { mainTheme } from "../../theme/mainTheme";

const ThemeProvider = ({ children }) => {
  const { theme } = useTheme();
  const isShopifyApp = useShopifyApp();

  const userTheme = useMemo(() => {
    if (theme === "testTheme") {
      return shopifyTheme;
    }

    if (isShopifyApp) {
      return shopifyTheme;
    }

    return mainTheme;
  }, [theme, isShopifyApp]);

  return <Provider theme={userTheme}>{children}</Provider>;
};

export default ThemeProvider;
